
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.ModellingViewFormatGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class ModellingViewFormatGrid extends SiteEntityGrid<ModellingViewFormatRow, any> 
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.ModellingViewFormat'; }
        protected getDialogType() { return ModellingViewFormatDialog; }
        protected getIdProperty() { return ModellingViewFormatRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewFormatRow.localTextPrefix; }
        protected getService() { return ModellingViewFormatService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        private _columnSetCode: string;

        public set columnSetCode(value: string) {
            if (this._columnSetCode !== value) {
                this._columnSetCode = value;
                this.setEquality(ModellingViewColumnRow.Fields.ColumnSetCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<ModellingViewFormatRow>{
                ColumnSetCode: this._columnSetCode
            });
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._columnSetCode;
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._columnSetCode);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }
    }
}